import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SidebarProvider } from './contexts/SidebarContext';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { Properties } from './pages/Properties';
import { PropertyDetail } from './pages/PropertyDetail';
import { Brands } from './pages/Brands';
import { BrandDetail } from './pages/BrandDetail';
import { ClientiReferenti } from './pages/ClientiReferenti';
import { ClientiEsigenze } from './pages/ClientiEsigenze';
import { Deals } from './pages/Deals';
import { Calendar } from './pages/Calendar';
import { SentCampaigns } from './pages/campaigns/SentCampaigns';
import { NewCampaign } from './pages/campaigns/NewCampaign';
import { Automation } from './pages/campaigns/Automation';
import { DealEmails } from './pages/campaigns/DealEmails';
import { TeamDashboard } from './pages/team/TeamDashboard';
import { TeamMembers } from './pages/team/TeamMembers';
import { TeamPerformance } from './pages/team/TeamPerformance';
import { TeamWorkload } from './pages/team/TeamWorkload';
import { TeamActivities } from './pages/team/TeamActivities';
import { PropertyMatching } from './pages/utility/PropertyMatching';
import { NeedsMatching } from './pages/utility/NeedsMatching';
import { StreetAnalysis } from './pages/utility/StreetAnalysis';
import { StrategyPlanner } from './pages/utility/StrategyPlanner';
export function App() {
  return <BrowserRouter data-id="element-0">
      <SidebarProvider data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Layout data-id="element-4" />} data-id="element-3">
            <Route index element={<Dashboard data-id="element-6" />} data-id="element-5" />
            <Route path="properties" element={<Properties data-id="element-8" />} data-id="element-7" />
            <Route path="properties/:id" element={<PropertyDetail data-id="element-10" />} data-id="element-9" />
            <Route path="clienti/aziende" element={<Brands data-id="element-12" />} data-id="element-11" />
            <Route path="clienti/aziende/:id" element={<BrandDetail data-id="element-14" />} data-id="element-13" />
            <Route path="clienti/referenti" element={<ClientiReferenti data-id="element-16" />} data-id="element-15" />
            <Route path="clienti/esigenze" element={<ClientiEsigenze data-id="element-18" />} data-id="element-17" />
            <Route path="brands" element={<Navigate to="/clienti/aziende" replace data-id="element-20" />} data-id="element-19" />
            <Route path="brands/:id" element={<Navigate to="/clienti/aziende/:id" replace data-id="element-22" />} data-id="element-21" />
            <Route path="deals" element={<Deals data-id="element-24" />} data-id="element-23" />
            <Route path="calendar" element={<Calendar data-id="element-26" />} data-id="element-25" />
            <Route path="campaigns" element={<SentCampaigns data-id="element-28" />} data-id="element-27" />
            <Route path="campaigns/new" element={<NewCampaign data-id="element-30" />} data-id="element-29" />
            <Route path="campaigns/automation" element={<Automation data-id="element-32" />} data-id="element-31" />
            <Route path="campaigns/deals" element={<DealEmails data-id="element-34" />} data-id="element-33" />
            <Route path="team" element={<TeamDashboard data-id="element-36" />} data-id="element-35" />
            <Route path="team/members" element={<TeamMembers data-id="element-38" />} data-id="element-37" />
            <Route path="team/performance" element={<TeamPerformance data-id="element-40" />} data-id="element-39" />
            <Route path="team/workload" element={<TeamWorkload data-id="element-42" />} data-id="element-41" />
            <Route path="team/activities" element={<TeamActivities data-id="element-44" />} data-id="element-43" />
            <Route path="utility/needs-matching" element={<NeedsMatching data-id="element-46" />} data-id="element-45" />
            <Route path="utility/property-matching" element={<PropertyMatching data-id="element-48" />} data-id="element-47" />
            <Route path="utility/street-analysis" element={<StreetAnalysis data-id="element-50" />} data-id="element-49" />
            <Route path="utility/strategy-planner" element={<StrategyPlanner data-id="element-52" />} data-id="element-51" />
          </Route>
        </Routes>
      </SidebarProvider>
    </BrowserRouter>;
}